import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {Card, Col, List, Row} from 'antd';
import {Button, DatePicker, Select } from 'antd/lib/index'
import moment from 'moment';
import common from '../../common.less'
import CounselingIcon from '../../../assets/icons/counsellar/CounselingIcon.png';
import RegistrationIcon from '../../../assets/icons/counsellar/RegistrationIcon.png';
import Request from '../../../request';
import styles from './styles.less'
import _ from 'lodash'
import InquiryReport from '../../../components/reports/inquiryReports';

import Chart from "react-apexcharts";

const { RangePicker } = DatePicker
const {Option} = Select

const colors = ['#46b3a9', '#cdc755', '#a826b7', '#febc3b', '#ff6178', '#8b75d7', '#6d848e', '#26e7a6', '#2cadd5', '#26a0fc'];

class AllVisaDepartmentReport extends Component {
  state = {
    showInquiryReport: false,
    branchId: '',
    associatePartnerId: '',
    countryId: '',
    counsellerId: '',
    directCollegeId: '',
    indirectCollegeId: '',
    time: {
      from: moment().clone().startOf('month'),
      to: moment().clone().endOf('month')
    },
    allUsers: [],
    allBranches: [],
    allPartners: [],
    allCountries: [],
    allDirectColleges: [],
    allIndirectColleges: [],

    deadInquiries: [],

    series: [],
    options: {
      chart: {
        height: 350,
        type: 'bar',
        events: {
          click: function(chart, w, e) {
            // console.log(chart, w, e)
          }
        }
      },
      colors: colors,
      plotOptions: {
        bar: {
          columnWidth: '45%',
          distributed: true,
        }
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false
      },
      xaxis: {
        categories: [
          'List of Dead Inquiry'
        ],
        labels: {
          style: {
            colors: colors,
            fontSize: '12px'
          }
        }
      }
    }
  };

  loadFilterData = async() => {
    const response = await Request.getReportFilterData();
    if(response) {
      this.setState({
        allBranches: response.branchs,
        allPartners: response.chennalPartners,
        allCountries: response.countries,
        allDirectColleges: response.directUniversities,
        allIndirectColleges: response.indirectUniversities
      });
    }
  }

  async loadUsers() {
    let {branchId} = this.state
    let {data: userLists} = await Request.loadUser({results: 10000, userBranch: branchId})
    let userList = []
    _.each(userLists, (item) => {
        userList.push({value: item._id, text: item.name})
    })
    this.setState({allUsers: userList})
  }

  loadReportStates = async() => {

    const { branchId, counsellerId, associatePartnerId, countryId, directCollegeId, indirectCollegeId, time } = this.state;
    const params = {
      branchId, counsellerId, associatePartnerId, countryId, directCollegeId, indirectCollegeId, time
    };
    const response = await Request.getDeadInquiryReportStates(params);
    if(response) {
      this.setState({
        series: [{
          data: [
            response.totaldeadInquiries
          ]
        }],
        deadInquiries: [
          {
            text: 'Total',
            value: response.totaldeadInquiries
          }
        ]
      });
    }
  }

  onOk = value => {
    this.loadReportStates()
  }

  chooseRangerPicker = (date, dateString) => {
    this.setState(
      {
        time: {
          from: date[0],
          to: date[1]
        }
      }, () => {
        if (date[0] === undefined) {
          this.loadReportStates()
        }
      }
    )
  }

  openInquiry = async(type, value) => {
    this.setState({type: type, total: value, showInquiryReport: true });
  }
  closeInquiryReport = async() => {
    this.setState({ showInquiryReport: false });
  }

  componentWillMount() {
    this.loadFilterData();
    this.loadReportStates();
  }

  async componentDidMount() {

  }

  render() {
    
    const {allBranches, allUsers, allPartners, allCountries, allDirectColleges, allIndirectColleges} = this.state;

    const { deadInquiries } = this.state;

    const { branchId, counsellerId, associatePartnerId, countryId, directCollegeId, indirectCollegeId, time, type, total, showInquiryReport } = this.state;

    const params = {
      branchId, counsellerId, associatePartnerId, countryId, directCollegeId, indirectCollegeId, time, type, total
    };
    
    const startOfMonth = moment().clone().startOf('month').format('YYYY-MM-DD HH:mm:ss');
    const endOfMonth = moment().clone().endOf('month').format('YYYY-MM-DD HH:mm:ss');

    return (
      <PageHeaderWrapper title={` Dead Inquiry Reports `}>
        { 
          showInquiryReport ? 
            <InquiryReport params={params} onClose={this.closeInquiryReport}/>
          :null
        }
        <div className="site-card-wrapper">
          <Card style={{ marginBottom: 10 }}>
            <div>
              <Row>
                <Col span={8}>
                  <label>Date Range</label>
                  <RangePicker
                    showTime={{ format: 'HH:mm' }}
                    format="YYYY-MM-DD HH:mm"
                    placeholder={[startOfMonth, endOfMonth]}
                    onChange={this.chooseRangerPicker}
                    onOk={this.onOk}
                  />
                </Col>
                <Col span={1}></Col>
                <Col span={4}>
                  <label>Branch Wise</label>
                  <Select
                    showSearch
                    allowClear
                    optionFilterProp="children"
                    style={{
                      width: 225,
                      marginRight: 16
                    }}
                    value={this.state.branchId}
                    placeholder="Select Option"
                    onChange={branchId => {
                      this.setState(
                        {
                          branchId: branchId && branchId.toString(),
                          userId: ''
                        },
                        () => {
                          this.loadUsers()
                        }
                      )
                    }}>
                    {allBranches.map((val, idn) => {
                      return (
                        <Option key={idn} value={val.branchId}>
                          {val.branchName}
                        </Option>
                      )
                    })}
                  </Select>                    
                </Col>                
                <Col span={1}></Col>
                <Col span={4}>
                  <label>Counsellor Wise</label>
                  <Select
                    showSearch
                    allowClear
                    optionFilterProp="children"
                    value={this.state.counsellerId}
                    placeholder="Select Option"
                    style={{
                      width: 225,
                      marginRight: 16
                    }}
                    onChange={userId => {
                      this.setState(
                        {
                          counsellerId: userId && userId.toString()
                        },
                        () => {
                          this.loadReportStates()
                        }
                      )
                    }}>
                    {allUsers.map((val, idn) => {
                      return (
                        <Option key={idn} value={val.value}>
                          {val.text}
                        </Option>
                      )
                    })}
                  </Select>
                </Col>
                <Col span={1}></Col>
                <Col span={4}>
                  <label>Associate Partner Wise</label>
                  <Select
                    allowClear
                    style={{
                      width: 225,
                      marginRight: 16
                    }}
                    showSearch={true}
                    className={common.width100Pr}
                    value={this.state.associatePartnerId}
                    placeholder="Select Option"
                    optionFilterProp="display"
                    onChange={associatePartnerId => {
                      this.setState(
                        {
                          associatePartnerId: associatePartnerId && associatePartnerId.toString()
                        },
                        () => {
                          this.loadReportStates()
                        }
                      )
                    }}
                    filterOption={(input, option) => {
                      return (
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      )
                    }}>
                      {allPartners.map((val, idn) => {
                        return (
                          <Option key={idn} value={val._id}>
                            {val.channelPartnerName}
                          </Option>
                        )
                      })}
                  </Select>
                </Col>
                <Col span={1}></Col>
                <Col span={4}>
                  <label>Country Wise</label>
                  <Select
                    allowClear
                    style={{
                      width: 225,
                      marginRight: 16
                    }}
                    showSearch={true}
                    className={common.width100Pr}
                    value={this.state.countryId}
                    placeholder="Select Option"
                    optionFilterProp="display"
                    onChange={countryId => {
                      this.setState(
                        {
                          countryId: countryId && countryId.toString()
                        },
                        () => {
                          this.loadReportStates()
                        }
                      )
                    }}
                    filterOption={(input, option) => {
                      return (
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      )
                    }}>
                      {allCountries.map((val, idn) => {
                        return (
                          <Option key={idn} value={val.countryId}>
                            {val.countryName}
                          </Option>
                        )
                      })} 
                  </Select>
                </Col>
                <Col span={1}></Col>
                <Col span={4}>
                  <label>Direct Colleges</label>
                  <Select
                    allowClear
                    style={{
                      width: 225,
                      marginRight: 16
                    }}
                    showSearch={true}
                    className={common.width100Pr}
                    value={this.state.directCollegeId}
                    placeholder="Select Option"
                    optionFilterProp="display"
                    onChange={directCollegeId => {
                      this.setState(
                        {
                          directCollegeId: directCollegeId && directCollegeId.toString()
                        },
                        () => {
                          this.loadReportStates()
                        }
                      )
                    }}
                    filterOption={(input, option) => {
                      return (
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      )
                    }}>
                      {allDirectColleges.map((val, idn) => {
                        return (
                          <Option key={idn} value={val.id}>
                            {val.universityInstitutionName}
                          </Option>
                        )
                      })}
                  </Select>
                </Col>
                <Col span={1}></Col>
                <Col span={4}>
                  <label>Indirect Colleges</label>
                  <Select
                    allowClear
                    style={{
                      width: 225,
                      marginRight: 16
                    }}
                    showSearch={true}
                    className={common.width100Pr}
                    value={this.state.indirectCollegeId}
                    placeholder="Select Option"
                    optionFilterProp="display"
                    onChange={indirectCollegeId => {
                      this.setState(
                        {
                          indirectCollegeId: indirectCollegeId && indirectCollegeId.toString()
                        },
                        () => {
                          this.loadReportStates()
                        }
                      )
                    }}
                    filterOption={(input, option) => {
                      return (
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      )
                    }}>
                      {allIndirectColleges.map((val, idn) => {
                        return (
                          <Option key={idn} value={val.id}>
                            {val.universityInstitutionName}
                          </Option>
                        )
                      })}
                  </Select>
                </Col>
                <Col span={1}></Col>
                <Col span={4}>
                  <label>&nbsp;<br></br>&nbsp;</label>
                  <div className='antd-pro-containers-finance-all-styles-myBtnGroup'>
                    <Button
                      type={'primary'}
                      className={styles.btn}
                      onClick={() => this.loadReportStates()}> Search
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </Card>
          <Row gutter={16}>
            <Col span={12}>
              <Card
                headStyle={{
                  backgroundColor: '#46b3a9',
                  color: 'white',
                  minHeight: '11px',
                  fontSize: '15px'
                }}
                style={{height: '184px', marginTop: "20px"}}
                bodyStyle={{padding: '4px'}}
                title={
                  <span><img src={CounselingIcon} alt="Smiley face" height="22" width="22"/>
                  <span style={{paddingLeft: '10px'}}>Dead Inquiry Total</span></span>
                }>
                <List
                  size="small"
                  bordered={false}
                  dataSource={deadInquiries}
                  renderItem={val => (
                    <List.Item>
                      <div style={{display: 'flex', justifyContent: 'space-around', width: '100%'}}>
                        <div style={{color: '#46b3a9'}}>{val.text}</div>
                        <div>-</div>
                        <div><button onClick={(e) => {this.openInquiry('Dead Inquiry', val.value)}}>{val.value}</button></div>
                      </div>
                    </List.Item>)
                  }
                >
                </List>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card
                headStyle={{
                  backgroundColor: '#2B208D',
                  color: 'white',
                  minHeight: '11px',
                  fontSize: '15px'
                }}
                style={{minHeight: '384px', marginTop: "20px"}}
                bodyStyle={{padding: '4px'}}
                title={
                  <span>
                    <img src={RegistrationIcon} alt="Smiley face" height="22" width="22"/>
                    <span style={{paddingLeft: '5px'}}>Dead Inquiry Report Chart</span>
                  </span>
                }>
                  <Chart options={this.state.options} series={this.state.series} type="bar" width={1100} height={350} />
                </Card>
            </Col>
          </Row>
        </div>
      </PageHeaderWrapper>
    );
  }
}

export default AllVisaDepartmentReport
